import { defineCapability } from './internal';
import { args } from '../common/args';
export const CHANGE_SEARCH_FILTER_CAP = defineCapability({
  name: 'CHANGE_SEARCH_FILTER_CAP',
  args: {
    filters: args.arrayOf(args.string())
  }
});